// The banner of a hosted database that is not open (task 2026-10-05 "a hosted database can be
// archived read-only"): maintenance (a migration, an archiving, or an admin's reason) or
// archived (read-only until an admin un-archives it, with the final release's citation; cold storage said too).
// `hosting` is a hosting answer of the backend (services/hosting.py: mode, banner, archive) —
// the sentence itself is the backend's (deps.mode_banner), the same one a refused write gets.
const BOX = { margin: "12px 0 0", padding: "10px 14px", borderRadius: 8, fontSize: 13 };
const AMBER = { background: "rgba(217,119,6,0.08)", border: "1px solid rgba(217,119,6,0.35)", color: "#92400e" };
const GREY = { background: "#f3f4f6", border: "1px solid #d1d5db", color: "#1f2937" };

export default function HostingModeBanner({ hosting }) {
  if (!hosting || !hosting.mode || hosting.mode === "open" || !hosting.banner) return null;
  const a = hosting.archive || {};
  if (hosting.mode === "archived") {
    const cold = a.state === "cold" || a.state === "restoring";
    return (
      <div role="status" data-testid="archive-banner" style={{ ...BOX, ...GREY }}>
        <strong>Archived.</strong> {hosting.banner}
        {cold && (
          <span style={{ display: "block", marginTop: 4 }}>
            {a.state === "restoring"
              ? "The database is being restored from cold storage."
              : "The database is in cold storage (dumped and dropped); an admin restores it to read it again. The releases stay downloadable."}
          </span>
        )}
        {a.citation && (
          <span style={{ display: "block", marginTop: 6 }}>
            Cite it as: <cite data-testid="archive-citation">{a.citation}</cite>
            {a.release_url && <> · <a href={a.release_url}>release {a.release}</a></>}
          </span>
        )}
      </div>
    );
  }
  return (
    <div role="status" data-testid="maintenance-banner" style={{ ...BOX, ...AMBER }}>
      <strong>Maintenance.</strong> {hosting.banner}
    </div>
  );
}
